export default ngModule => {
  ngModule.controller('ComparatorStep3CtrlAHM', function ($scope) {
    this.resetPaymentDateRange = () => {
      let payment = $scope.ctrl.application.payment;
      this.minJoinDate = new Date();
      this.minDebitDate = payment.join_date;
      payment.debit_date = this.minDebitDate > payment.debit_date ? this.minDebitDate : payment.debit_date;
    }
    this.resetPaymentDateRange();

    $scope.$watch('ctrl.application.payment.join_date', () => {
      this.resetPaymentDateRange();
    });

    $scope.$watch('ahmctrl.application.dependants', () => {
      if (_.get(this.application, 'dependants', []).length) {
        for (let d of this.application.dependants) {
          if (this.isBabyPending(_.get(d, 'relationship'))) {
            _.set(d, 'title', '');
            _.set(d, 'first_name', '');
            _.set(d, 'gender', '');
            _.set(d, 'dob', '');
          }
        }
      }
    }, true);

  });
}



// WEBPACK FOOTER //
// ./src/controllers/comparator/step3-ctrl-ahm.js